import {Component, inject, Input, OnInit} from '@angular/core';
import {ButtonDirective} from "primeng/button";
import {CommonModule, NgClass} from "@angular/common";
import {IGetTramitesBusqueda} from "../../../shared/interfaces/configuracion";
import {ResultadosBusquedaComponent} from "../resultados-busqueda/resultados-busqueda.component";
import {TranslatePipe} from "@ngx-translate/core";
import {ActivatedRoute, Router, RouterLink} from "@angular/router";
import { TooltipModule } from 'primeng/tooltip';
import { LocalService } from 'lib-base';
import {StyleClassModule} from "primeng/styleclass";
import {DividerModule} from "primeng/divider";

@Component({
  selector: 'app-item-tramite-resultado',
  standalone: true,
  imports: [
    ButtonDirective, CommonModule,
    NgClass,
    TranslatePipe,
    RouterLink,
    TooltipModule, StyleClassModule, DividerModule
  ],
  templateUrl: './item-tramite-resultado.component.html',
  styleUrl: './item-tramite-resultado.component.scss'
})
export class ItemTramiteResultadoComponent implements OnInit {
  @Input({required: true}) item: IGetTramitesBusqueda | undefined;
  @Input('classCard') classCard: string | string[] | undefined;
  @Input('text') text: string | undefined;
  @Input() styleCard: Record<string, string | undefined | null> | string | undefined;
  @Input() index: number | undefined;

  @Input() set styleContent(value: 'card' | 'list' | undefined) {
    this._styleContent = value;
    if (value == 'list') this.styleClass = 'content-details';
  }
  basePath: string = '';
   _styleContent: 'card' | 'list' | undefined = 'card';
  styleClass: string | undefined;
  private parent: ResultadosBusquedaComponent = inject(ResultadosBusquedaComponent);
  private readonly router: Router = inject(Router);
  private readonly _activeRouter: ActivatedRoute = inject(ActivatedRoute);

  ngOnInit(): void {
    this._activeRouter.parent?.url.subscribe((url) => {
      this.basePath = url[0]?.path;
    });
  }


  constructor( private _ls: LocalService) {
  }

  onInitTramite() {
    if (this.item)
      this.parent.onIniciarTramite(this.item);
  }

  iniciarTramiteDisabled(item: IGetTramitesBusqueda) {
    if(!this._ls.isLoggedIn){
      return false;
    }
    if(this._ls.isFirmaElectronicaExpired){
      return true;
    }else if(item.requierePago && !item.costoVigente){
      return true;
    }
    return false;
  }

  iniciarTramiteTooltip(item: IGetTramitesBusqueda): string{
    if(this._ls.isFirmaElectronicaExpired){
      return "msg.firmaElectronicaNoHabilitada";
    }else{
      return "msg.tramiteInactivo";
    }
  }
  consultaEstado() {
    this.router.navigateByUrl('/sede-electronica/estado-tramite').then();
  }


}
